<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Silent hours') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  "ProjectSettings|Project silent hours allow you to define time periods when group chat notifications should not be sent. This helps maintain focus during specific hours and respects team members' quiet time."
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  "ProjectSettings|You can configure silent hours for the project with a start and end time. During these periods, notifications for new tasks, comments, and updates will not be sent to the group chat. Times are displayed in the project's preferred timezone."
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Project Silent Hours Digest') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|When project silent hours end, a scheduled job runs every minute to check if the silent hours period has just finished. If so, a digest message will be sent to the group chat shortly after silent hours end, containing all notifications that were suppressed during the silent period.'
                )
              }}
            </p>
            <p>
              {{
                s__(
                  'ProjectSettings|If no notifications occurred during silent hours, no digest will be sent to the group chat.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Use Cases') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Project silent hours are useful for maintaining work-life balance across the team, avoiding interruptions during meetings or focused work sessions, and respecting different time zones. The digest ensures important updates are not missed while respecting quiet time.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
